import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";

import { StackRunsBulkActionsConfirmActionStepProps } from "./types";

type StackRunsBulkActionsConfirmActionStepDefaultProps = StackRunsBulkActionsConfirmActionStepProps;

const StackRunsBulkActionsConfirmActionStepDefault = ({
  stack,
  action,
  bulkActionsVariant,
  onConfirm,
  onCancel,
}: StackRunsBulkActionsConfirmActionStepDefaultProps) => {
  const handleConfirm = () => {
    onConfirm(
      { stack },
      {
        view: bulkActionsVariant,
        metadata: {},
      }
    );
  };

  return (
    <BulkActionsConfirmActionStepInlineConfirmation
      variant={bulkActionsVariant}
      actionLabel={action.title.toLowerCase()}
      onConfirm={handleConfirm}
      onCancel={onCancel}
    />
  );
};

export default StackRunsBulkActionsConfirmActionStepDefault;
